<script src="https://www.google.com/recaptcha/api.js"></script>
<template>
  <div class="p-0 container-fluid">
    <div class="g-0 row">
      <div class="col-xl-9">
        <div class="auth-full-bg pt-lg-5 p-4">
          <div class="w-100">
            <div class="bg-overlay"></div>
          </div>
        </div>
      </div>
      <div class="col-xl-3">
        <div class="auth-full-page-content p-md-5 p-4">
          <div class="w-100">
            <div class="d-flex flex-column h-100">
              <div class="mb-4 mb-md-5">
                <img
                  src="https://unicampo.coop.br/uploads/bkp/2022/portal/logo.png"
                  height="45"
                />
              </div>
              <div class="my-auto">
                <div>
                  <div>
                    <h5 class="text-primary">Bem-Vindo(a)!</h5>
                    <p class="text-muted">
                      Entre para utilizar o Portal Unicampo
                    </p>
                  </div>

                  <div v-if="alerta" class="m-auto">
                    <b-alert show :variant="variante" v-if="!showAlertEmail">
                      {{ mensagem }}
                    </b-alert>

                    <b-alert show variant="danger" v-else>
                      {{ mensagem }}
                      <div v-if="showAlertToken">
                        <br /><br />
                        Caso não tenha recebido o e-mail,
                        <router-link
                          to="/reenvioEmail"
                          variant="link"
                          class="p-0"
                        >
                          Clique aqui
                        </router-link>
                        para receber uma nova confirmação no e-mail.
                      </div>
                    </b-alert>
                  </div>

                  <!-- FORMULÁRIO DE LOGIN -->
                  <form @keyup.enter="submit" @submit.prevent="submit">
                    <div class="mb-3">
                      <emailCpf
                        label="Email ou CPF"
                        inputText="Digite um e-mail ou CPF"
                        inputInvalid="Digite um e-mail ou CPF válido"
                        :validado="verificaEmailCpf"
                        v-on:emitindoEmailCpf="atribuiEmailCpf"
                        tabindex="1"
                      />
                    </div>

                    <div class="mb-2">
                      <div class="float-end">
                        <a
                          class="text-muted div-clickable"
                          tabindex="-1"
                          @click="showModal = true"
                        >
                          Esqueceu a senha?
                        </a>
                      </div>
                    </div>

                    <div class="mb-3">
                      <senha
                        label="Senha"
                        inputText="Digite uma senha"
                        inputInvalid="Digite um senha válida"
                        :mostraSenha="true"
                        :validado="verificaPassword"
                        v-on:emitindoSenha="atribuiSenha"
                        tabindex="1"
                      />
                    </div>

                    <vue-recaptcha
                      ref="recaptcha"
                      size="invisible"
                      @verify="verifyMethod"
                      sitekey="6LebGvweAAAAAFnTI7kT4HBEvkfpo-mDg-Ndfq2D"
                    >
                    </vue-recaptcha>

                    <div class="mt-3 d-grid">
                      <button
                        class="btn btn-primary btn-block"
                        type="submit"
                        :disabled="loading"
                      >
                        Entrar
                      </button>
                    </div>
                  </form>

                  <div class="mt-3 text-center">
                    <p>
                      Não tem acesso?
                      <router-link to="/cadastrocandidato">
                        <a
                          href="/cadastrocandidato"
                          class="fw-medium text-primary"
                          target="_blank"
                        >
                          Cadastre-se aqui
                        </a>
                      </router-link>
                    </p>
                  </div>
                </div>

                <div class="mt-4 text-center">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-primary text-white border-primary"
                        href="https://pt-br.facebook.com/UNICAMPO/"
                        target="_blank"
                      >
                        <i class="mdi mdi-facebook"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-danger bg-gradient text-white border-danger"
                        href="https://www.instagram.com/unicampo_coop"
                        target="_blank"
                      >
                        <i class="mdi mdi-instagram"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-info text-white border-info"
                        href="https://br.linkedin.com/company/unicampo"
                        target="_blank"
                      >
                        <i class="mdi mdi-linkedin"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="social-list-item bg-danger text-white border-danger"
                        href="https://www.youtube.com/channel/UCiskgZkQPOzT6i4AdY0JbAw"
                        target="_blank"
                      >
                        <i class="mdi mdi-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="mt-4 mt-md-5 text-center">
                <p class="mb-0">
                  © {{ new Date().getFullYear() }} UNICAMPO. Todos os direitos
                  Reservados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template>
      <b-modal v-model="showModal" title="Esqueceu a senha?" size="lg">
        <div class="row">
          <div class="col-12">
            <label style="size: 18px; text-align: center">
              Para redefinir a sua senha, informe o seu e-mail no campo abaixo.
              Enviaremos um e-mail com link de redefinição de senha.
            </label>
          </div>

          <div class="col-12">
            <emailCpf
              label="E-mail"
              inputText="Digite um e-mail"
              inputInvalid="Digite um e-mail válido"
              :validado="null"
              v-on:emitindoEmailCpf="atribuiEmailCpf"
              tabindex="1"
              ref="componentEmail"
            />
          </div>

          <div class="col-12">
            <label class="mt-2" style="size: 18px">
              Se precisar de ajuda, entre em contato:
            </label>
            <div style="size: 18px">Telefone: (44) 4009-3800</div>
            <div style="size: 18px">Email: unicampo@unicampo.coop.br</div>
          </div>
        </div>

        <template v-slot:modal-footer>
          <b-button variant="danger" @click="showModal = false">
            Cancelar
          </b-button>

          <b-button
            variant="success"
            @click="enviarEmailRedefinirSenha()"
            :disabled="loading"
          >
            Enviar
            <b-spinner small class="ms-2" v-if="loading"></b-spinner>
          </b-button>
        </template>
      </b-modal>
    </template>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt";
import { VueRecaptcha } from "vue-recaptcha";
import { required } from "vuelidate/lib/validators";
import senha from "@/components/formulario/senha-input";
import emailCpf from "@/components/formulario/emailCpf-input";

export default {
  components: { emailCpf, senha, VueRecaptcha },
  layout: "empty",

  data() {
    return {
      auth: {
        email: "",
        cpf: "",
        password: ""
      },
      emailRedefinir: "",
      submitted: false,
      alerta: false,
      mensagem: null,
      verificaEmailCpf: null,
      verificaPassword: null,
      showModal: false,
      loading: false,
      showAlertEmail: false,
      showAlertToken: false,
      showValidaEmail: true,
      challengeId: null,
      challengeNonce: null,
      challengePublicKey: null
    };
  },

  created() {
    this.$tools.getIp();
    this.$tools.abrirMenu();

    if (this.$store.state.access_token) {
      this.$router.push("/");
    } else if (this.$route.path != "/login") {
      this.$router.push("/login");
    }
  },

  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function(position) {
          window.latLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        },
        function(error) {
          alert(
            "Erro ao obter localização! Para nos ajudar e melhorar o sistema habilite a localização"
          );
          console.log("Erro ao obter localização.", error);
        }
      );
    } else {
      console.log("Navegador não suporta Geolocalização!");
    }
  },

  validations: {
    auth: {
      password: {
        required
      }
    }
  },

  methods: {
    atribuiSenha(senha) {
      this.auth.password = senha;
    },

    atribuiEmailCpf(emailCpf) {
      const valor = String(emailCpf || "").trim();

      const somenteNumeros = valor.replace(/\D/g, "");

      if (somenteNumeros.length === 11) {
        this.auth.cpf = somenteNumeros;
        this.auth.email = "";
      } else {
        this.auth.email = valor;
        this.auth.cpf = "";
      }

      this.emailRedefinir = valor;
    },

    async getChallenge() {
      const response = await this.$http.post("api/auth/challenge", {
        email: this.auth.email || null,
        cpf: this.auth.cpf.replace(/\D/g, "") || null
      });

      const payload = response.data?.data || response.data;
      const { challenge_id, nonce, public_key } = payload;

      if (!challenge_id || !nonce || !public_key) {
        throw new Error(
          "Não foi possível iniciar a validação temporária de autenticação."
        );
      }

      const normalizedPublicKey = this.normalizePublicKey(public_key);

      this.challengeId = challenge_id;
      this.challengeNonce = nonce;
      this.challengePublicKey = normalizedPublicKey;

      return {
        ...payload,
        public_key: normalizedPublicKey
      };
    },

    encryptLoginPayload(password, nonce, publicKey) {
      const encryptor = new JSEncrypt();
      encryptor.setPublicKey(publicKey);

      const now = Math.floor(Date.now() / 1000);
      const expiresAt = now + 60;

      const subject = this.auth.email || this.auth.cpf || "";

      const internalPayload = JSON.stringify({
        sub: subject,
        aud: "portal-auth-login",
        password,
        nonce,
        iat: now,
        exp: expiresAt,
        jti: this.generateJti()
      });

      const encryptedPayload = encryptor.encrypt(internalPayload);

      if (!encryptedPayload) {
        throw new Error("Falha ao criptografar payload de login");
      }

      return encryptedPayload;
    },

    generateJti() {
      if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
      }

      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    normalizePublicKey(publicKey) {
      if (!publicKey) {
        return "";
      }

      if (
        publicKey.includes("-----BEGIN PUBLIC KEY-----") &&
        publicKey.includes("-----END PUBLIC KEY-----")
      ) {
        return publicKey;
      }

      const sanitizedKey = publicKey.replace(/\r?\n|\r/g, "").trim();
      const formattedKey =
        sanitizedKey.match(/.{1,64}/g)?.join("\n") || sanitizedKey;

      return `-----BEGIN PUBLIC KEY-----\n${formattedKey}\n-----END PUBLIC KEY-----`;
    },

    async login() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.alerta = true;
        this.variante = "danger";
        this.mensagem = "Preencha todos os campos abaixo para continuar";
        this.verificaEmailCpf = false;
        this.verificaPassword = false;
        return;
      }

      try {
        this.loading = true;
        this.alerta = false;
        this.mensagem = null;
        this.showAlertEmail = false;
        this.showAlertToken = false;

        const challengeResponse = await this.getChallenge();

        const encryptedPayload = this.encryptLoginPayload(
          this.auth.password,
          challengeResponse.nonce,
          challengeResponse.public_key
        );

        const userPayload = {
          email: this.auth.email || "",
          cpf: this.auth.cpf || "",
          challenge_id: challengeResponse.challenge_id,
          payload: encryptedPayload
        };

        await this.$store.dispatch("login", userPayload);

        this.submitted = false;
        this.loading = false;

        await Promise.all([
          this.verificaDocumentoJuridico(),
          this.verificaDocumentoAssembleia(),
          this.verificarPendenciaAssinaturaEletronica(),
          this.verificarInfoBancaria(),
          this.verificarEsocial(),
          this.verificaTelEmergencia()
        ]);

        this.$router.push("/");
      } catch (err) {
        this.submitted = false;
        this.loading = false;
        this.alerta = true;
        this.variante = "danger";
        this.showAlertEmail = true;
        this.showAlertToken = false;

        if (this.$refs.recaptcha) {
          this.$refs.recaptcha.reset();
        }

        const status = err.response?.status;
        const message = err.response?.data?.message || err.message;

        if (status === 422) {
          const validationErrors = err.response?.data?.errors;

          if (validationErrors?.email?.length) {
            this.mensagem = validationErrors.email[0];
          } else if (validationErrors?.cpf?.length) {
            this.mensagem = validationErrors.cpf[0];
          } else if (validationErrors?.challenge_id?.length) {
            this.mensagem = validationErrors.challenge_id[0];
          } else if (validationErrors?.payload?.length) {
            this.mensagem = validationErrors.payload[0];
          } else {
            this.mensagem = message || "Dados inválidos para autenticação.";
          }

          this.verificaEmailCpf = false;
          this.verificaPassword = false;
        } else if (status === 404) {
          this.mensagem = message || "E-mail não validado.";
          this.showAlertToken = true;
        } else if (status === 401) {
          this.mensagem = message || "E-mail, CPF e/ou senha inválido(s).";
          this.verificaPassword = false;
        } else if (status === 403) {
          this.mensagem = message || "Usuário não está ativo.";
          this.verificaPassword = false;
        } else if (status === 410) {
          this.mensagem =
            message || "Validação temporária expirada. Tente novamente.";
        } else if (status === 500) {
          this.mensagem = message || "Erro interno ao processar autenticação.";
        } else {
          this.mensagem = message || "Erro ao fazer login. Tente novamente.";
          this.verificaPassword = false;
        }
      }
    },

    submit() {
      if (
        this.$http.defaults.baseURL == "https://portal-api.unicampo.coop.br/"
      ) {
        this.$refs.recaptcha.execute();
      } else {
        this.login();
      }
    },

    verifyMethod(token) {
      this.$http
        .get("api/auth/recaptcha/" + token)
        .then(response => {
          if (response.data.success) {
            this.login();
          } else {
            this.$tools.alerta("Recaptcha Invalido", "error");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    async verificaDocumentoJuridico() {
      const user = this.$store.state.me;

      await this.$http
        .get("api/lgpd/verificarTermoConsentimento/" + user.nr_docto)
        .then(response => {
          if (response.data.ExisteDocumento == 1) {
            this.$store.commit("VALIDA_TERMO_LGPD", true);
          } else {
            this.$store.commit("VALIDA_TERMO_LGPD", false);
          }
        })
        .catch(() => {
          this.$store.commit("VALIDA_TERMO_LGPD", true);
        });
    },

    async verificaDocumentoAssembleia() {
      await this.$http
        .get("api/reuniao/verificarTermo")
        .then(response => {
          const sq_upload = response.data.sq_upload;

          if (sq_upload) {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", false);
            this.$store.commit("TERMO_ASSEMBLEIA", sq_upload);
          } else {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
          }
        })
        .catch(() => {
          this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
        });
    },

    async verificarPendenciaAssinaturaEletronica() {
      await this.$http
        .get("api/assinaturaEletronica/verificarPendenciaAssinaturaEletronica")
        .then(response => {
          if (response.data.length > 0) {
            if (
              response.data[0].TIPOPENDENCIA === "S" &&
              response.data[0].SQUPLOADPENDENCIA !== null
            ) {
              this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", false);
            } else {
              this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
            }
          } else {
            this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
          }
        })
        .catch(() => {
          this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
        });
    },

    async verificarInfoBancaria() {
      try {
        const respSituacao = await this.$http.get(
          "api/cadastroCandidato/verificaInfoBancaria"
        );

        if (respSituacao.status === 200) {
          this.$store.commit("INFO_BANCARIA", false);
          localStorage.setItem("validacao-info-bancaria", "false");
        } else {
          this.$store.commit("INFO_BANCARIA", true);
        }
      } catch (error) {
        const infoBancariaFlag = localStorage.getItem(
          "validacao-info-bancaria"
        );

        if (
          error.response &&
          error.response.status === 403 &&
          !infoBancariaFlag
        ) {
          this.$store.commit("INFO_BANCARIA", true);
        }
      }
    },

    async verificarEsocial() {
      await this.$http
        .get("api/cadastroCandidato/atualizaRacaCor")
        .then(response => {
          if (response.data.status) {
            this.$store.commit("VALIDA_ESOCIAL", true);
          }
        })
        .catch(() => {
          this.$store.commit("VALIDA_ESOCIAL", true);
        });
    },

    async verificaTelEmergencia() {
      try {
        const respData = await this.$http.get(
          "api/cadastroCandidato/consultaContatos"
        );

        if (respData.data.status == 500) {
          this.$store.commit("TEL_EMERGENCIA", true);
        }

        this.dadosCadastrais = respData.data.dados;

        const telEmergenciaFlag = localStorage.getItem("validacao-tel-recados");

        if (
          (respData.data.validacao === "V" && !telEmergenciaFlag) ||
          respData.data.status == 500
        ) {
          this.$store.commit("TEL_EMERGENCIA", true);
        } else {
          this.$store.commit("TEL_EMERGENCIA", false);
          localStorage.setItem("validacao-tel-recados", "false");
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error === "Nenhum registro encontrado"
        ) {
          this.$store.commit("TEL_EMERGENCIA", true);
        } else {
          console.error("Erro ao consultar contatos:", error);
        }
      }
    },

    enviarEmailRedefinirSenha() {
      this.loading = true;

      const email = this.auth.email?.trim();

      if (!email) {
        this.$tools.alerta(
          "O campo de e-mail não pode estar vazio.",
          "warning"
        );
        this.loading = false;
        return;
      }

      if (!this.$refs.componentEmail.validaCampo()) {
        this.loading = false;
        return;
      }

      this.$http
        .get("api/auth/enviarEmailRedefinirSenha/" + this.auth.email)
        .then(() => {
          this.$tools.alerta(
            "Você receberá um e-mail com link de redefinição de senha em até 24 horas. Verifique sua caixa de entrada.",
            "success"
          );
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$tools.alerta(err.response.data.message, "error");
        });
    }
  }
};
</script>
